import { render, staticRenderFns } from "./Legal.vue?vue&type=template&id=649e560a&scoped=true"
import script from "./Legal.vue?vue&type=script&lang=js"
export * from "./Legal.vue?vue&type=script&lang=js"
import style0 from "./Legal.vue?vue&type=style&index=0&id=649e560a&prod&lang=scss"
import style1 from "./Legal.vue?vue&type=style&index=1&id=649e560a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649e560a",
  null
  
)

export default component.exports